import React from "react";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { Box } from "@mui/material";

export const Animation_Success_animation = ({ color }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        backgroundColor: "#F0FFF4",
        border: "3px solid #2E7D3280",
        borderRadius: "50%",
        padding: "20px",
      }}
    >
      {/* Fondo de icono blanco */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          width: "80px",
          backgroundColor: "#FFFFFF",
          borderRadius: "50%",
        }}
      >
        <CheckCircleOutlinedIcon sx={{ fontSize: 100, color: color }} />
      </Box>
    </Box>
  );
};

export default Animation_Success_animation;
